import ProductCard from '@/components/ProductCard/ProductCard'
import type {Product} from '@/models/productModel'
import VisuallyHidden from '@/utils/a11y/VisuallyHidden'
import style from '@/views/Stores/StoreFront.module.scss'

interface StoreResultsSectionProps {
  title: string
  q: string
  products: Product[]
}

export default function StoreResultsSection({title, q, products}: StoreResultsSectionProps) {
  return (
    <section aria-labelledby='store-results-title'>
      <div className={`${style.SectionHeader} ${style.SectionHeaderLeft}`}>
        <h2 id='store-results-title' className={`${style.SectionTitle} ${style.SectionTitleSmall}`}>
          {`Results for "${q}" in ${title}`}
        </h2>
      </div>
      {products.length === 0 ? (
        <div role='status' aria-live='polite'>
          <p className={style.NoResults}>No results found.</p>
        </div>
      ) : (
        <div className={style.Products}>
          {products.map(product => (
            <VisuallyHidden
              as='div'
              key={`${product.retailer}-${product.id}`}
              className={style.Product}
              isVisible={
                product.retailer !== 'amazon' && (product as {seller?: string}).seller !== 'amazon'
              }
            >
              <ProductCard product={product} headingLevel={3} />
            </VisuallyHidden>
          ))}
        </div>
      )}
    </section>
  )
}
